import { render } from "./WeChatCallbackView.vue?vue&type=template&id=1fb5ba7e&scoped=true"
import script from "./WeChatCallbackView.vue?vue&type=script&lang=js"
export * from "./WeChatCallbackView.vue?vue&type=script&lang=js"

import "./WeChatCallbackView.vue?vue&type=style&index=0&id=1fb5ba7e&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fb5ba7e"]])

export default __exports__